// ─── SMS provider presets ────────────────────────────────────────────────────
// Selecting a provider_type auto-fills the template fields with known-good
// defaults. "custom" leaves everything editable for a provider not listed here.
const SMS_PROVIDER_PRESETS = {
    generic: {
        label: "Generic (Africa's Talking style)",
        payload_template: JSON.stringify({
            apikey: '{{api_key}}',
            partnerID: '{{partner_id}}',
            mobile: '{{to}}',
            message: '{{text}}',
            shortcode: '{{short_code}}'
        }),
        headers_template: JSON.stringify({ 'Content-Type': 'application/json' }),
        response_success_path: '__http_status__',
        response_success_value: '200',
        response_message_id_path: '',
        needs_access_key: false
    },
    onfon: {
        label: 'Onfon Media',
        payload_template: JSON.stringify({
            SenderId: '{{short_code}}',
            IsUnicode: false,
            IsFlash: false,
            MessageParameters: [{ Number: '{{to}}', Text: '{{text}}' }],
            ApiKey: '{{api_key}}',
            ClientId: '{{partner_id}}'
        }),
        headers_template: JSON.stringify({ 'Content-Type': 'application/json', AccessKey: '{{access_key}}' }),
        response_success_path: 'ErrorCode',
        response_success_value: '0',
        response_message_id_path: 'Data[0].MessageId',
        needs_access_key: true
    },
    custom: {
        label: 'Custom (advanced)',
        payload_template: '',
        headers_template: JSON.stringify({ 'Content-Type': 'application/json' }),
        response_success_path: '__http_status__',
        response_success_value: '200',
        response_message_id_path: '',
        needs_access_key: false
    }
};

export default SMS_PROVIDER_PRESETS;
